// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { Params } from '@feathersjs/feathers';
import type { ClientApplication } from '../../client';
import type {
  UserCollectionItem,
  UserCollectionItemData,
  UserCollectionItemPatch,
  UserCollectionQuery,
  UserCollectionService,
} from './user-collection.class';

export type {
  UserCollectionItem,
  UserCollectionItemData,
  UserCollectionItemPatch,
  UserCollectionQuery,
};

export type UserCollectionClientService = Pick<
  UserCollectionService<Params<UserCollectionQuery>>,
  (typeof userCollectionMethods)[number]
>;

export const userCollectionPath = 'api/user-collection';

export const userCollectionMethods: Array<keyof UserCollectionService> = [
  'find',
  'create',
  'patch',
  'remove',
  'importCollection',
  'importLetterboxd',
  'clearCollection',
  'ownedFilmIds',
  'watchedFilmIds',
  'watchlistFilmIds',
  'memberships',
  'matchItem',
  'unmatchedFilms',
  'missingFilms',
  'dismissMissingFilm',
  'restoreMissingFilm',
  'claimMissingFilm',
  'releaseMissingFilm',
  'shelf',
  'summary',
  'bulkRemove',
  'bulkSetFormats',
  'undo',
];

export const userCollectionClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(userCollectionPath, connection.service(userCollectionPath), {
    methods: userCollectionMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [userCollectionPath]: UserCollectionClientService;
  }
}
